
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as _91integrationName_93_p_YhN6C1j6dP6xTR_0SeidhbUc1GqRtNmpVCQVyXOMMeta } from "/app/pages/datamanagement/integrationhub/[integrationName].vue?macro=true";
import { default as _91pipelineId_93Ezr3hm_GVB5EIMm3rZR_krJ_Kht_I7ppYnmd22WXPMcMeta } from "/app/pages/datamanagement/pipelines/[pipelineId].vue?macro=true";
import { default as _91widgetId_93IrILgLGDc0dF_FywhzFP0tcV0dfxJqcH3J6S5GjrfVkMeta } from "/app/pages/portfolio/property/[propertyId]/transform/[widgetId].vue?macro=true";
import { default as balanceJ_ogLviUzK3DyUg4og7aE5309mqD1H15oczyiw5vrvUMeta } from "/app/pages/portfolio/property/[propertyId]/balance.vue?macro=true";
import { default as capexesIGJOlFJR_U_aXuLfyo_ZMcvuByN9c2QnqfilH3iX8LoMeta } from "/app/pages/portfolio/property/[propertyId]/capexes.vue?macro=true";
import { default as opexvoQrEJGLhtBrfmNuSlFdwDWau89DBkNSw4bWIaKPc2QMeta } from "/app/pages/portfolio/property/[propertyId]/opex.vue?macro=true";
import { default as printCFSIt5i1m_QEZgiWiLtxEgj2EqirOup2DcszldqIfkUMeta } from "/app/pages/portfolio/property/[propertyId]/print.vue?macro=true";
import { default as sales0a9KI3re9mOoquNicrCc7Yt6dpt9Z_CHW_w9p7gs4gwMeta } from "/app/pages/portfolio/property/[propertyId]/sales.vue?macro=true";
import { default as unitsZBA_plpGVklkbb102BA_rv3kKqCZp9pmj3NV_k_bfA0Meta } from "/app/pages/portfolio/property/[propertyId]/units.vue?macro=true";
import { default as valuationsBrImDBqeIS5G0TSqxgmCbordxFx1CUCOxD8zI8_xAVMMeta } from "/app/pages/portfolio/property/[propertyId]/valuations.vue?macro=true";
import { default as indexneaveC4TpcYbv4H6EBw074vpASUqhAFYb65AKyl_jzAMeta } from "/app/pages/portfolio/property/[propertyId]/index.vue?macro=true";
import { default as _91propertyId_930CI0l93fSxNf0QVSpjk6HMLDXWx4XyiHWQz4DDoU2NYMeta } from "/app/pages/portfolio/property/[propertyId].vue?macro=true";
import { default as index3vc8Nx4i5vliA_tPE79rxHG3IUAFe3LJONFEjb4dOl0Meta } from "/app/pages/portfolio/tenancy/[tenancyId]/account-statement/index.vue?macro=true";
import { default as index_hEU_cf1pXdtdFiBYWvoijMm2C5m1EFhip1nCTvBoCgMeta } from "/app/pages/portfolio/tenancy/[tenancyId]/arrears/index.vue?macro=true";
import { default as indexJsnC2BMsQLrr8PVGjWtA1yTbe5vMFZAOcyBL0M6x5TMMeta } from "/app/pages/portfolio/tenancy/[tenancyId]/capexes/index.vue?macro=true";
import { default as indexYpeXsxpE2DoxW5PPcJMAeH5YDexkww7QtzKqWwhAn0UMeta } from "/app/pages/portfolio/tenancy/[tenancyId]/overview/index.vue?macro=true";
import { default as indexyHIMvAz9s5ISBOmtZZRfZrUsh7etYM7QRBSJz4TTmpMMeta } from "/app/pages/portfolio/tenancy/[tenancyId]/sales/index.vue?macro=true";
import { default as indexHCenz4Ym8Ww10_RNom0R3NyDh9JvgCdm0_bLoZm6kOAMeta } from "/app/pages/portfolio/tenancy/[tenancyId]/tenant/index.vue?macro=true";
import { default as indexLJ_klL44QOcllz4Pq6ukkGfHQJn7md4RVwZO8wP4HNUMeta } from "/app/pages/portfolio/tenancy/[tenancyId]/valuations/index.vue?macro=true";
import { default as _91tenancyId_93c13vDpEW57ZttQNZ_MXOdO_WiUtvTJnmjlC_01fgc6gMeta } from "/app/pages/portfolio/tenancy/[tenancyId].vue?macro=true";
import { default as indexFPJTe_OR0mnGy3kJHyROhocuFCsOv6C0uUOFNbht0lQMeta } from "/app/pages/datamanagement/datamapping/account-mapping/index.vue?macro=true";
import { default as indexUfE2tjLZpCkx0f_jAK5DVRu2Gn64MW8Ft_kZ7kmV2NEMeta } from "/app/pages/datamanagement/datamapping/category-mapping/index.vue?macro=true";
import { default as indexqTXYXUqnEkn_ZOPW9OQZYjQSVcpqhX8Y03P_PUxMA_kMeta } from "/app/pages/datamanagement/datamapping/custom-fields-mapping/index.vue?macro=true";
import { default as index3BjguiFbNJbVWYhid45VkQwDQZm44fiT0tGbfxJmfzMMeta } from "/app/pages/datamanagement/datamapping/portfolio-mapping/index.vue?macro=true";
import { default as indexNENiFS5L4pzSPu2GLZ9TSdUYyKov3cHR22r1mKrmSlsMeta } from "/app/pages/datamanagement/datamapping/property-mapping/index.vue?macro=true";
import { default as indexs0hcL3SSzowMbsRcLOppM5vJfP7LlYIPUSw1fmHG3DAMeta } from "/app/pages/datamanagement/datamapping/tenancy-mapping/index.vue?macro=true";
import { default as indexhXQzdj6WAZrM17sk_s_xhq2pUzXGLyG8dzlKQbXBiXAMeta } from "/app/pages/datamanagement/datamapping/index.vue?macro=true";
import { default as datamappingZJmlTkd0VHccM0wtstRIg_5r9dwXJNDF7OS70DsYFL8Meta } from "/app/pages/datamanagement/datamapping.vue?macro=true";
import { default as index_D42z69_fxSl7TqtDg_bjWG7ueun1bxaGdSZQArNsQwMeta } from "/app/pages/datamanagement/integrationhub/index.vue?macro=true";
import { default as indexufNdeO2Dkolhklrp5jZycakSTaJGianSgs4liHpEp8YMeta } from "/app/pages/datamanagement/pipelines/index.vue?macro=true";
import { default as balanceO01v5w0SGXxdb_xAC1cuo3kOVyad93BESZZlcec_3EgMeta } from "/app/pages/portfolio/[portfolioId]/balance.vue?macro=true";
import { default as companiesXzi0JDz51mBE2NfSkPwdSQ_x5dVGlaqGvSqXnwny0mIMeta } from "/app/pages/portfolio/[portfolioId]/companies.vue?macro=true";
import { default as opexjEtm3NW11chNxPkbPieiEiTGquvtQtXrVSnCB8P0p1oMeta } from "/app/pages/portfolio/[portfolioId]/opex.vue?macro=true";
import { default as propertiesER1BcVmTczkcOEGjkWBOGeuetRBPKvidtOnHZKsRqfEMeta } from "/app/pages/portfolio/[portfolioId]/properties.vue?macro=true";
import { default as tenanciesPJB7UPkRwWJCjDV69rjLykqtFKK10VwVMXnVPJjd0bwMeta } from "/app/pages/portfolio/[portfolioId]/tenancies.vue?macro=true";
import { default as indexMI4I7sxO8wCPZrbvlCUjW_vEu_F4PcTAlPAgFYnJNCcMeta } from "/app/pages/portfolio/[portfolioId]/index.vue?macro=true";
import { default as _91portfolioId_93NK7CyweArchQhrjerISCwU_Mb65q5wnQ4jddVm8GkxkMeta } from "/app/pages/portfolio/[portfolioId].vue?macro=true";
import { default as _91widgetId_93Z5hlNkg8_xmiFeEClY8b0MhU5EjFhYjxOV2GXyZAlBsMeta } from "/app/pages/reports/[layoutId]/transform/[widgetId].vue?macro=true";
import { default as print6uUuyU8UjrqAorMcD7dnN0BUCO2UB6mr1SJ9sUTGeIQMeta } from "/app/pages/reports/[layoutId]/print.vue?macro=true";
import { default as index34RgdgDbCdEU_0iPDn1_YPpcKPnPXMlQmXk0NkcnTwwMeta } from "/app/pages/reports/[layoutId]/index.vue?macro=true";
import { default as _91layoutId_93H74mXsC7LjO2YC_UMTdhx88hpT0hHZLjRkk8x7J7PvcMeta } from "/app/pages/reports/[layoutId].vue?macro=true";
import { default as accountsu1SjbzBqNYpJ_RWc5BpgftGETd_QpbN_FzjCYRbaVK0Meta } from "/app/pages/accounts.vue?macro=true";
import { default as indexFEuC4nsE4XgRvk4cE71tSnJukot7yzowrMxDtdUmEZ0Meta } from "/app/pages/analytics/index.vue?macro=true";
import { default as assetsliep8h2BYRyTp2J4IZ6VAIePHJBLDz3qcavkfmSjjZwMeta } from "/app/pages/assets.vue?macro=true";
import { default as indexvhfhWVotO_6VvDOq_cYkZMmeSIieYf1jIKy2UpS3yT0Meta } from "/app/pages/auth/index.vue?macro=true";
import { default as index3cHpOvA8brJXgzMtG6LWNabMqYFTIkQke_LjYkzstkUMeta } from "/app/pages/canvas-reports/index.vue?macro=true";
import { default as layout_45previewqOqLiE3nUW_s9gZxq_0CYbQXRm7D1IG6cTgEDF5ilDAMeta } from "/app/pages/layout-preview.vue?macro=true";
import { default as index06RuUPKkpIkYJ1u5ZQ6kHhkE76Z6rwcTsSwg0fLJR9IMeta } from "/app/pages/login/index.vue?macro=true";
import { default as opextrackerD4PvNE_NDu86GXY2Lk40bkZx_7cz0b2mEHQ6hiCA9ksMeta } from "/app/pages/opextracker.vue?macro=true";
import { default as rentrollMXymO7C16hi2TRuA1RxmXK7PKLQo1PMTXqwm6zYbcWwMeta } from "/app/pages/rentroll.vue?macro=true";
import { default as indexP_T7wPh_aodPu5ikFWVi4tb5ggCS9bYgYggORuX_lvAMeta } from "/app/pages/reports/index.vue?macro=true";
import { default as indexDLzw_g6D6DIAJf6VenrnDjf_u__OCTUbhH1U0CiVKeoMeta } from "/app/pages/settings/index.vue?macro=true";
import { default as _91config_93Shy2dXGVDrA6KxRsOEBQLbWIxKsJfva76RpcrpcugMsMeta } from "/app/pages/widget-builder/[config].vue?macro=true";
import { default as indexq_Ys_4RjC8IqZzmWlH2X8uTQqgJUEboFhvJ4dDKegs8Meta } from "/app/pages/widget-builder/index.vue?macro=true";
import { default as widget_45builderwgvWotpYvmtvEyeSW5_71xpxexPC_h9QAi2g5jUgz2MMeta } from "/app/pages/widget-builder.vue?macro=true";
import { default as widget_45wizardh0IbbjiAUAboYaF_cNAHtQLRtxhdSAXLoWDu6QzXR0YMeta } from "/app/pages/widget-wizard.vue?macro=true";
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_7f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
export default [
  {
    name: "datamanagement-integrationhub-integrationName",
    path: "/datamanagement/integrationhub/:integrationName()",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/datamanagement/integrationhub/[integrationName].vue")
  },
  {
    name: "datamanagement-pipelines-pipelineId",
    path: "/datamanagement/pipelines/:pipelineId()",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/datamanagement/pipelines/[pipelineId].vue")
  },
  {
    name: _91propertyId_930CI0l93fSxNf0QVSpjk6HMLDXWx4XyiHWQz4DDoU2NYMeta?.name,
    path: "/portfolio/property/:propertyId()",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/property/[propertyId].vue"),
    children: [
  {
    name: "portfolio-property-propertyId-transform-widgetId",
    path: "transform/:widgetId()",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/property/[propertyId]/transform/[widgetId].vue")
  },
  {
    name: "portfolio-property-propertyId-balance",
    path: "balance",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/property/[propertyId]/balance.vue")
  },
  {
    name: "portfolio-property-propertyId-capexes",
    path: "capexes",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/property/[propertyId]/capexes.vue")
  },
  {
    name: "portfolio-property-propertyId-opex",
    path: "opex",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/property/[propertyId]/opex.vue")
  },
  {
    name: "portfolio-property-propertyId-print",
    path: "print",
    meta: { ...(printCFSIt5i1m_QEZgiWiLtxEgj2EqirOup2DcszldqIfkUMeta || {}), ...{"middleware":["auth0","feature-flags-hooks"]} },
    component: () => import("/app/pages/portfolio/property/[propertyId]/print.vue")
  },
  {
    name: "portfolio-property-propertyId-sales",
    path: "sales",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/property/[propertyId]/sales.vue")
  },
  {
    name: "portfolio-property-propertyId-units",
    path: "units",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/property/[propertyId]/units.vue")
  },
  {
    name: "portfolio-property-propertyId-valuations",
    path: "valuations",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/property/[propertyId]/valuations.vue")
  },
  {
    name: "portfolio-property-propertyId",
    path: "",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/property/[propertyId]/index.vue")
  }
]
  },
  {
    name: "portfolio-tenancy-tenancyId",
    path: "/portfolio/tenancy/:tenancyId()",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/tenancy/[tenancyId].vue"),
    children: [
  {
    name: "portfolio-tenancy-tenancyId-account-statement",
    path: "account-statement",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/tenancy/[tenancyId]/account-statement/index.vue")
  },
  {
    name: "portfolio-tenancy-tenancyId-arrears",
    path: "arrears",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/tenancy/[tenancyId]/arrears/index.vue")
  },
  {
    name: "portfolio-tenancy-tenancyId-capexes",
    path: "capexes",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/tenancy/[tenancyId]/capexes/index.vue")
  },
  {
    name: "portfolio-tenancy-tenancyId-overview",
    path: "overview",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/tenancy/[tenancyId]/overview/index.vue")
  },
  {
    name: "portfolio-tenancy-tenancyId-sales",
    path: "sales",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/tenancy/[tenancyId]/sales/index.vue")
  },
  {
    name: "portfolio-tenancy-tenancyId-tenant",
    path: "tenant",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/tenancy/[tenancyId]/tenant/index.vue")
  },
  {
    name: "portfolio-tenancy-tenancyId-valuations",
    path: "valuations",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/tenancy/[tenancyId]/valuations/index.vue")
  }
]
  },
  {
    name: datamappingZJmlTkd0VHccM0wtstRIg_5r9dwXJNDF7OS70DsYFL8Meta?.name,
    path: "/datamanagement/datamapping",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/datamanagement/datamapping.vue"),
    children: [
  {
    name: "datamanagement-datamapping-account-mapping",
    path: "account-mapping",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/datamanagement/datamapping/account-mapping/index.vue")
  },
  {
    name: "datamanagement-datamapping-category-mapping",
    path: "category-mapping",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/datamanagement/datamapping/category-mapping/index.vue")
  },
  {
    name: "datamanagement-datamapping-custom-fields-mapping",
    path: "custom-fields-mapping",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/datamanagement/datamapping/custom-fields-mapping/index.vue")
  },
  {
    name: "datamanagement-datamapping-portfolio-mapping",
    path: "portfolio-mapping",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/datamanagement/datamapping/portfolio-mapping/index.vue")
  },
  {
    name: "datamanagement-datamapping-property-mapping",
    path: "property-mapping",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/datamanagement/datamapping/property-mapping/index.vue")
  },
  {
    name: "datamanagement-datamapping-tenancy-mapping",
    path: "tenancy-mapping",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/datamanagement/datamapping/tenancy-mapping/index.vue")
  },
  {
    name: "datamanagement-datamapping",
    path: "",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/datamanagement/datamapping/index.vue")
  }
]
  },
  {
    name: "datamanagement-integrationhub",
    path: "/datamanagement/integrationhub",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/datamanagement/integrationhub/index.vue")
  },
  {
    name: "datamanagement-pipelines",
    path: "/datamanagement/pipelines",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/datamanagement/pipelines/index.vue")
  },
  {
    name: _91portfolioId_93NK7CyweArchQhrjerISCwU_Mb65q5wnQ4jddVm8GkxkMeta?.name,
    path: "/portfolio/:portfolioId()",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/[portfolioId].vue"),
    children: [
  {
    name: "portfolio-portfolioId-balance",
    path: "balance",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/[portfolioId]/balance.vue")
  },
  {
    name: "portfolio-portfolioId-companies",
    path: "companies",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/[portfolioId]/companies.vue")
  },
  {
    name: "portfolio-portfolioId-opex",
    path: "opex",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/[portfolioId]/opex.vue")
  },
  {
    name: "portfolio-portfolioId-properties",
    path: "properties",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/[portfolioId]/properties.vue")
  },
  {
    name: "portfolio-portfolioId-tenancies",
    path: "tenancies",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/[portfolioId]/tenancies.vue")
  },
  {
    name: "portfolio-portfolioId",
    path: "",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/[portfolioId]/index.vue")
  }
]
  },
  {
    name: _91layoutId_93H74mXsC7LjO2YC_UMTdhx88hpT0hHZLjRkk8x7J7PvcMeta?.name,
    path: "/reports/:layoutId()",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/reports/[layoutId].vue"),
    children: [
  {
    name: "reports-layoutId-transform-widgetId",
    path: "transform/:widgetId()",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/reports/[layoutId]/transform/[widgetId].vue")
  },
  {
    name: "reports-layoutId-print",
    path: "print",
    meta: { ...(print6uUuyU8UjrqAorMcD7dnN0BUCO2UB6mr1SJ9sUTGeIQMeta || {}), ...{"middleware":["auth0","feature-flags-hooks"]} },
    component: () => import("/app/pages/reports/[layoutId]/print.vue")
  },
  {
    name: "reports-layoutId",
    path: "",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/reports/[layoutId]/index.vue")
  }
]
  },
  {
    name: "accounts",
    path: "/accounts",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/accounts.vue")
  },
  {
    name: "analytics",
    path: "/analytics",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/analytics/index.vue")
  },
  {
    name: "assets",
    path: "/assets",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/assets.vue")
  },
  {
    name: "auth",
    path: "/auth",
    meta: { ...(indexvhfhWVotO_6VvDOq_cYkZMmeSIieYf1jIKy2UpS3yT0Meta || {}), ...{"middleware":["auth0","feature-flags-hooks"]} },
    component: () => import("/app/pages/auth/index.vue")
  },
  {
    name: "canvas-reports",
    path: "/canvas-reports",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/canvas-reports/index.vue")
  },
  {
    name: "layout-preview",
    path: "/layout-preview",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/layout-preview.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: { ...(index06RuUPKkpIkYJ1u5ZQ6kHhkE76Z6rwcTsSwg0fLJR9IMeta || {}), ...{"middleware":["auth0","feature-flags-hooks"]} },
    component: () => import("/app/pages/login/index.vue")
  },
  {
    name: "opextracker",
    path: "/opextracker",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/opextracker.vue")
  },
  {
    name: "rentroll",
    path: "/rentroll",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/rentroll.vue")
  },
  {
    name: "reports",
    path: "/reports",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/reports/index.vue")
  },
  {
    name: "settings",
    path: "/settings",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/settings/index.vue")
  },
  {
    name: widget_45builderwgvWotpYvmtvEyeSW5_71xpxexPC_h9QAi2g5jUgz2MMeta?.name,
    path: "/widget-builder",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/widget-builder.vue"),
    children: [
  {
    name: "widget-builder-config",
    path: ":config()",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/widget-builder/[config].vue")
  },
  {
    name: "widget-builder",
    path: "",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/widget-builder/index.vue")
  }
]
  },
  {
    name: "widget-wizard",
    path: "/widget-wizard",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/widget-wizard.vue")
  },
  {
    name: "index",
    path: "/",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/index.vue")
  }
]